var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBitcoin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_398",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29041",
    "data-name": "Group 29041",
    transform: "translate(-4265 4899)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4265, -4899)",
    filter: "url(#Ellipse_398)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_398-2",
    "data-name": "Ellipse 398",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-bitcoin",
    transform: "translate(4281 -4886)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50739",
    "data-name": "Path 50739",
    d: "M37,20.5A16.5,16.5,0,1,1,20.5,4,16.5,16.5,0,0,1,37,20.5Z",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50740",
    "data-name": "Path 50740",
    d: "M17,30.5V14h6.764a7.483,7.483,0,0,1,4.521,1.151,3.944,3.944,0,0,1,1.54,3.371,3.772,3.772,0,0,1-.615,2.137,3.578,3.578,0,0,1-1.721,1.354A3.446,3.446,0,0,1,29.471,23.3,3.788,3.788,0,0,1,30.2,25.65a4.366,4.366,0,0,1-1.508,3.6A6.762,6.762,0,0,1,24.4,30.5Zm3.3-9.9h3.6c1.7-.029,2.556-.68,2.556-2.017a1.9,1.9,0,0,0-.648-1.615,3.388,3.388,0,0,0-2.044-.493H20.3Zm0,2.475v4.95h4c.793,0,2.6-.387,2.6-2.152s-.922-2.775-2.475-2.8Z",
    transform: "translate(-2.275 -1.75)",
    fill: "#fff8e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50741",
    "data-name": "Path 50741",
    d: "M20,11h2.475v4.125H20Zm4.125,0H26.6v4.125H24.125ZM20,28.325h2.475V32.45H20Zm4.125,0H26.6V32.45H24.125Z",
    transform: "translate(-2.8 -1.225)",
    fill: "#fff8e1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoin);
export default __webpack_public_path__ + "static/media/bitcoin.3c731be282c77d2ca380f96ded603f10.svg";
export { ForwardRef as ReactComponent };